import { destroyCookie, parseCookies, setCookie } from 'nookies';
/* this can be used in the callback of Object.keys or Object.entries */
var cookieBeginsWithPrefix = function (cookiePrefix) { return function (cookieName) {
    if (typeof cookieName === 'string')
        return cookieName.startsWith(cookiePrefix);
    return cookieName[0].startsWith(cookiePrefix);
}; };
var makeCookieStorage = function (cookiePrefix) {
    function clear() {
        Object.keys(parseCookies())
            .filter(cookieBeginsWithPrefix(cookiePrefix))
            .forEach(function (cookieName) {
            destroyCookie(null, cookieName);
        });
    }
    function getItem(keyName) {
        return parseCookies()["".concat(cookiePrefix).concat(keyName)] || null;
    }
    function getAllItems() {
        return Object.entries(parseCookies())
            .filter(cookieBeginsWithPrefix(cookiePrefix))
            .reduce(function (acc, _a) {
            var keyName = _a[0], keyValue = _a[1];
            acc[keyName.replace(cookiePrefix, '')] = keyValue;
            return acc;
        }, {});
    }
    function removeItem(keyName) {
        destroyCookie(null, "".concat(cookiePrefix).concat(keyName));
    }
    function setItem(keyName, keyValue) {
        setCookie(null, "".concat(cookiePrefix).concat(keyName), keyValue);
    }
    function length() {
        return Object.keys(parseCookies()).filter(cookieBeginsWithPrefix(cookiePrefix)).length;
    }
    return {
        getItem: getItem,
        getAllItems: getAllItems,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        get length() {
            return length();
        },
    };
};
export var cookieStorageStrategy = function (cookiePrefix) {
    /**
     * This is required as we need to return a reference to the created
     * cookie storage implementation instead of rebuilding it each time
     * we go to use the storage instance
     * */
    var cookieStorage = makeCookieStorage(cookiePrefix);
    return {
        name: 'cookieStorageStrategy',
        isSupported: function () {
            if (typeof document === 'undefined' ||
                typeof document.cookie === 'undefined')
                return false;
            try {
                var testCookie = "".concat(cookiePrefix, "_test_key=test");
                document.cookie = testCookie;
                if (!document.cookie.includes(testCookie))
                    return false;
                document.cookie = "".concat(testCookie, "; expires=Thu, 01 Jan 1970 00:00:00 UTC;");
                if (document.cookie.includes(testCookie))
                    return false;
                return true;
            }
            catch (_a) {
                return false;
            }
        },
        storageInstance: function () { return cookieStorage; },
    };
};
